import { Card, Tab, Tabs } from "@mui/material";
import React from "react";

const ProfileTabs = (props) => {
  const handleChange = (e, newValue) => {
    props.setTab(newValue);
  };

  return (
    <Card 
      sx={{ 
        padding: 0,
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
      }}
    >
      <Tabs 
        value={props.tab} 
        onChange={handleChange} 
        variant="scrollable"
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
            minHeight: 56,
            "&.Mui-selected": {
              color: "#7C3AED",
            },
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#7C3AED",
            height: 3,
            borderRadius: "3px 3px 0 0",
          },
        }}
      >
        <Tab label="Posts" value="posts" />
        <Tab label="Liked" value="liked" />
        <Tab label="Comments" value="comments" />
      </Tabs>
    </Card>
  );
};

export default ProfileTabs;
